import { getFetchArgs, providesList } from "../../utils.js";
import { authoringApi } from "../api.js";
import { URL_SEGMENTS, TAGS } from "../common.js";
const resource = URL_SEGMENTS.GATE_TYPE;
const gateTypeApi = authoringApi.injectEndpoints({
  endpoints: (builder) => ({
    getGateTypeById: builder.query({
      query: (payload) => getFetchArgs({ resource, payload }),
      providesTags: (result, error, { id }) => [{ type: TAGS.GATE_TYPE, id }]
    }),
    queryGateTypes: builder.query({
      query: (payload) => getFetchArgs({ resource, payload }),
      providesTags: (result) => providesList(result == null ? void 0 : result.value, TAGS.GATE_TYPE)
    }),
    createOrUpdateGateType: builder.mutation({
      query: (payload) => getFetchArgs({ resource, payload, method: "PUT" }),
      invalidatesTags: (result, error, { entity }, meta) => {
        var _a;
        return providesList([entity], TAGS.GATE_TYPE, ((_a = meta == null ? void 0 : meta.response) == null ? void 0 : _a.status) === 201);
      }
    }),
    deleteGateType: builder.mutation({
      query: (payload) => getFetchArgs({ resource, payload, method: "DELETE" }),
      invalidatesTags: (result, error, { id }) => providesList([{ id }], TAGS.GATE_TYPE)
    })
  })
});
const {
  usePrefetch: usePrefetchGateTypes,
  useGetGateTypeByIdQuery,
  useLazyGetGateTypeByIdQuery,
  useQueryGateTypesQuery,
  useLazyQueryGateTypesQuery,
  useCreateOrUpdateGateTypeMutation,
  useDeleteGateTypeMutation
} = gateTypeApi;
export {
  gateTypeApi,
  useCreateOrUpdateGateTypeMutation,
  useDeleteGateTypeMutation,
  useGetGateTypeByIdQuery,
  useLazyGetGateTypeByIdQuery,
  useLazyQueryGateTypesQuery,
  usePrefetchGateTypes,
  useQueryGateTypesQuery
};
//# sourceMappingURL=gate-types.js.map
